import React from 'react'
import { useNetworkingBrief } from '../NetworkingBriefProvider'
import { EditorHeading } from '../../ResumeBuilder/Editor/common'
import { EditorItemField, EditorItemProvider } from './EditorItemProvider'
import { useTranslation } from '~/hooks/useTranslation'

const BasicsEditor = () => {
  const { networkingBriefDocument: { basics } = {} } = useNetworkingBrief()
  const { t } = useTranslation('BasicsEditor')

  return (
    <EditorItemProvider sectionName="basics" item={basics}>
      <div>
        <EditorHeading>{t('personal_information')}</EditorHeading>
        <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
          <EditorItemField
            containerClassName="md:col-span-2"
            label={t('full_name')}
            fieldName="name"
          />
          <EditorItemField label={t('current_position')} fieldName="position" />
          <EditorItemField label={t('company')} fieldName="company" />
          <EditorItemField
            label={t('company_city_state_optional')}
            fieldName="companyCityState"
          />
          <EditorItemField label={t('email_optional')} fieldName="email" />
          <EditorItemField label={t('phone_optional')} fieldName="phone" />
          <EditorItemField
            label={t('linkedin_optional')}
            fieldName="linkedin"
          />
        </div>
      </div>
    </EditorItemProvider>
  )
}

export default BasicsEditor
